import { getIntentKey } from '../routing/getIntentKey';
export const isIntent = intent => {
  const intentKey = getIntentKey();
  const intentKeysToCheck = Array.isArray(intent) ? intent : [intent];
  return intentKey ? intentKeysToCheck.includes(intentKey) : false;
};